export default "__VITE_ASSET__05962cdb__"